import type { Media } from "@zivin-labs/site-content";
import { Figure } from "../Figure";
import {
  AICTE_LOGO,
  NAAC_LOGO,
  NBA_LOGO,
  UGC_LOGO,
  VTU_LOGO,
} from "../../lib/accreditationMedia";

interface Accreditation {
  /** The body's own emblem; absent where there is no body to show a mark for. */
  logo?: Media;
  /** Fallback shown when there is no emblem. */
  mark?: string;
  name: string;
  sub: string;
}

/**
 * Exactly what the institute claims, in its own words. Its masthead reads
 * "Approved by AICTE, New Delhi | Accredited by NAAC with 'A' grade and NBA
 * (UG Programmes) | Recognized by UGC, New Delhi under 2(F) and 12(B)", and it
 * is an autonomous institute affiliated to VTU, Belagavi.
 *
 * An "ISO 9001 · Certified" badge used to sit in this row. It is not claimed
 * anywhere on bietdvg.edu — not in the masthead, not under its own
 * Accreditation / Ranking menu (AICTE, VTU, NAAC, NIRF, NBA, AISHE) — so it
 * has been dropped rather than left standing without a source. UGC recognition
 * takes its place, and NBA now carries the qualifier the institute uses.
 */
const ITEMS: Accreditation[] = [
  { logo: NAAC_LOGO, name: "NAAC", sub: "‘A’ grade" },
  { logo: NBA_LOGO, name: "NBA", sub: "UG programmes" },
  { logo: AICTE_LOGO, name: "AICTE", sub: "Approved" },
  { logo: VTU_LOGO, name: "VTU", sub: "Affiliated" },
  { logo: UGC_LOGO, name: "UGC", sub: "2(f) & 12(B)" },
  { mark: "AUTO", name: "Autonomous", sub: "Since 2024" },
];

export function Accreditations() {
  return (
    <section className="accreditations" id="accreditations">
      <div className="container">
        <div className="accred-row">
          {ITEMS.map((a) => (
            <div key={a.name} className="accred-item">
              <div className={"accred-mark" + (a.logo ? " accred-mark--logo" : "")}>
                {a.logo ? (
                  <Figure
                    media={a.logo}
                    fallbackLabel={a.name}
                    aspect="1/1"
                    className="accred-logo"
                    sizes="34px"
                  />
                ) : (
                  a.mark
                )}
              </div>
              <div className="accred-text">
                <div className="accred-name">{a.name}</div>
                <div className="accred-sub">{a.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
